import * as customerApi from 'api/CustomerApi'
import { getErrorCode, getErrorMessage, hasErrorCode } from 'api/utils'
import i18n from 'i18next'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { getErrorPopupProps } from 'utils'
import { PhoneNumberAvailableParams } from '../../typedef/customer'
import Translations from '../../utils/translations'
import { showPopup } from '../globalPopup/actions'
import { hideLoader, showLoader } from '../loader/actions'
import { AppState } from '../store'
import {
  reCaptchaFeature,
  reCaptchaVersion,
} from 'shared/ReCaptcha/ParkerLinkReCaptcha'
import { ErrorCode } from 'typedef'

//TODO: move to slice
export const resendRegistrationPin = (
  confirmToken: string,
  recaptchaToken: string | null,
  recaptchaVersion: reCaptchaVersion | null
) => {
  const displayResendErrorPopup = (
    dispatch: any,
    title?: string,
    description?: string
  ) => {
    if (!title) title = `${i18n.t(Translations.OOPS)}`
    if (!description)
      description = i18n.t(Translations.ACTIVATION_CODE_SEND_FAIL)

    dispatch(
      showPopup({
        variant: 'warning',
        title: title,
        description: description,
        handleAdditionalButtonClick: (token, version) => {
          dispatch(resendRegistrationPin(confirmToken, token, version))
        },
        withReCaptchaFeature: reCaptchaFeature.ResendPin,
      })
    )
  }

  return async (
    // eslint-disable-next-line @typescript-eslint/ban-types
    dispatch: ThunkDispatch<AppState, {}, Action>,
    getState: () => AppState
  ) => {
    dispatch(showLoader())

    try {
      const response = await customerApi.resendRegistrationPin({
        confirmToken,
        recaptchaToken,
        recaptchaVersion,
      })
      if (response === true) {
        dispatch(
          showPopup({
            variant: 'info',
            title: i18n.t(Translations.RESEND_CODE),
            description: i18n.t(Translations.ACTIVATION_CODE_HAS_BEEN_SENT),
            handleAdditionalButtonClick: () => undefined,
          })
        )
      } else {
        displayResendErrorPopup(dispatch)
      }
    } catch (error) {
      const errorMessage = getErrorMessage(getErrorCode(error))
      if (
        errorMessage.code === ErrorCode.FailedAttemptTimeout ||
        errorMessage.code === ErrorCode.FailedAttemptBan
      )
        displayResendErrorPopup(
          dispatch,
          errorMessage.title,
          errorMessage.description
        )
      else displayResendErrorPopup(dispatch)
    }

    dispatch(hideLoader())
  }
}

interface PhoneNumberAvailableArgs extends PhoneNumberAvailableParams {
  callback: () => void
}
export const phoneNumberAvailable = ({
  callback,
  ...args
}: PhoneNumberAvailableArgs) => {
  return async (
    // eslint-disable-next-line @typescript-eslint/ban-types
    dispatch: ThunkDispatch<AppState, {}, Action>,
    getState: () => AppState
  ) => {
    dispatch(showLoader())
    const result = await customerApi.phoneNumberAvailable(args)
    dispatch(hideLoader())

    if (hasErrorCode(result)) {
      dispatch(
        showPopup({
          ...getErrorPopupProps(result),
          handleAdditionalButtonClick: () =>
            dispatch(phoneNumberAvailable({ callback, ...args })),
        })
      )
      return false
    }
    if (!result.is) {
      dispatch(
        showPopup({
          title: i18n.t(Translations.ACCOUNT_ALREADY_EXISTS),
          description: i18n.t(Translations.PHONE_NUMBER_ALREADY_EXISTS),
          variant: 'error',
        })
      )
      return false
    }
    callback()
  }
}
